var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V19H30V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0866 6.87028L30.0002 0.844229V0H29.3208L18.0127 6.87028H20.0866Z",
    fill: "#BD0034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6216 12.5078L30 18.8153V17.5538L21.6955 12.5078H19.6216Z",
    fill: "#BD0034"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.44606L8.87664 6.87047H10.9595L0 0.18457V1.44606Z",
    fill: "#BD0034"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4857 12.5078L0 18.8832V18.9996H1.89511L12.5596 12.5078H10.4857Z",
    fill: "#BD0034"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9529 0H17.4404V6.38509L27.9529 0Z",
    fill: "#1A237B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8101 0H2.34229L12.8101 6.38509V0Z",
    fill: "#1A237B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.87067V2.51367L22.8755 6.87067H30Z",
    fill: "#1A237B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.8163V12.5078H22.8755L30 16.8163Z",
    fill: "#1A237B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94092 18.9998H12.8098V12.9932L2.94092 18.9998Z",
    fill: "#1A237B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 18.9998H27.3451L17.4404 12.9932V18.9998Z",
    fill: "#1A237B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5078V17.0201L7.37485 12.5078H0Z",
    fill: "#1A237B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.87066H7.37485L0 2.3584V6.87066Z",
    fill: "#1A237B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7306 0V7.99591H0V11.3825H13.7306V19H16.5197V11.3825H30V7.99591H16.5197V0H13.7306Z",
    fill: "#BD0034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.e7f25a1dc5abb5ef9c6cb21a992a73cf.svg";
export { ForwardRef as ReactComponent };